import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './animatedFlyingText.css'

/* istanbul ignore next */
const noop = () => {}

class AnimatedFlyingText extends PureComponent {
  renderAsMultiline () {
    const { underlineLines, children, onAnimationEnd, visible, delay, speed } = this.props

    return children.map((line, index) => (
      <div className={styles.lineWrap} key={line}>
        <div
          className={classnames(styles.line, {
            [styles.flyOut]: !visible,
            [styles.underlined]: underlineLines.indexOf(index) !== -1
          })}
          style={{ animationDelay: `${(delay + (index * 70)) / speed}ms` }}
          onAnimationEnd={(index === children.length - 1) ? onAnimationEnd : noop}
        >
          {line}
        </div>
      </div>
    ))
  }

  renderAsSingleBlock () {
    const { onAnimationEnd, children, visible, underlineLines, delay, speed } = this.props

    return (
      <span
        className={classnames(styles.line, {
          [styles.flyOut]: !visible,
          [styles.underlined]: underlineLines.length
        })}
        style={{ animationDelay: `${delay / speed}ms` }}
        onAnimationEnd={onAnimationEnd}
      >
        {children}
      </span>
    )
  }

  render () {
    const { children, className, inverted } = this.props

    return (
      <div className={classnames(className, inverted && styles.inverted)}>
        {Array.isArray(children)
          ? this.renderAsMultiline()
          : this.renderAsSingleBlock()
        }
      </div>
    )
  }
}

AnimatedFlyingText.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired,
  visible: PropTypes.bool,
  className: PropTypes.string,
  speed: PropTypes.number,
  delay: PropTypes.number,
  underlineLines: PropTypes.arrayOf(PropTypes.number),
  onAnimationEnd: PropTypes.func,
  inverted: PropTypes.bool
}

AnimatedFlyingText.defaultProps = {
  speed: 1,
  delay: 0,
  visible: true,
  className: null,
  underlineLines: [],
  onAnimationEnd: noop,
  inverted: false
}

export default AnimatedFlyingText
